<!-- 上传中断报警设置 -->
<template>
  <div>
    <a-card style="width: 100%; text-align: center">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" style="margin: 20px 0px 0px 20px">
          <a-row :gutter="12">
            <a-col :md="6" :sm="12">
              <a-form-item label="水表名称">
                <a-input v-model="query.deviceName" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12">
              <a-form-item label="水表编号">
                <a-input v-model="query.deviceNo" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12" style="display: flex">
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 12px" @click="resetList">重置</a-button>
              <a-button type="primary" style="margin-left: 12px" @click="title = '新增'; addOrUpdateHandle()">新增</a-button>
              <a-button type="primary" style="margin-left: 12px" @click="downloadTemplate">下载模板</a-button>
              <a-upload name="file" :multiple="false" @change="changeFile" :file-list="fileList"
                :customRequest="customRequest">
                <a-button type="primary" style="margin-left: 12px" :loading="importLoading">批量导入</a-button>
              </a-upload>
              <a-button type="danger" style="margin-left: 12px" @click="deleteSelectRow()">删除</a-button>
              <a-button type="primary" style="margin-left: 8px" :loading="exportLoading"
                @click="exportHandle()">导出</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-table ref="table" rowKey="id" :columns="columns"
        :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
        :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }" :data-source="list"
        :pagination="pagination" @change="pageChange" bordered>
        <span slot="action" slot-scope="text, record">
          <a @click="Handle(record)">编辑</a>
        </span>
        <span slot="deviceNameSlot" slot-scope="text,record">
          {{ record.deviceNo + '(' + record.deviceName + ')' }}
        </span>
        <span slot="pmtNameSlot" slot-scope="text">
          数据上传中断报警
        </span>
        <span slot="collectionFrequency" slot-scope="text">
          {{ text }}分钟/次
        </span>


        <span slot="openState" slot-scope="text">
          <a-tag color="#f12b35" v-if="text == 0">不开启</a-tag>
          <a-tag color="rgb(50, 205, 50)" v-else>开启</a-tag>
        </span>
      </a-table>
      <a-modal :title="title" width="50%" v-model="addOrUpdateVisible" @ok="handleOk" @cancel="handleCancel">
        <a-form :form="addOrUpdateForm" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
          <a-form-item label="分区选择">
            <a-tree-select :tree-data="zoneTreeData" :disabled="disabled" v-if="!disabled"
              v-decorator="['zoneitem', { rules: [{ required: true, message: '请选择分区' }] }]" style="width: 100%"
              show-search :replace-fields="{ title: 'zoneName', key: 'id', value: 'id', selectable: 'selectable' }"
              tree-node-filter-prop="title"
              :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" placeholder="请选择片区" allow-clear
              :label-in-value="true" @change="treechange" tree-default-expand-all></a-tree-select>
            <span v-else>{{nowItem.zoneName }}</span>
          </a-form-item>
          <a-form-item label="分区计量仪表">
            <div v-if="!disabled" class="zone-interrupt-meter-select-wrap">
              <a-select
                class="zone-interrupt-meter-select"
                v-decorator="['deviceNo', { rules: [{ required: true, message: '请选择' }] }]"
                placeholder="请选择"
                show-search
                option-filter-prop="children"
                :filter-option="filterMeterDeviceOption"
                :get-popup-container="(trigger) => trigger.parentNode"
                dropdown-class-name="zone-interrupt-meter-select-dropdown"
              >
                <a-select-option
                  v-for="item in equipmentList"
                  :key="item.appearanceNo"
                  :value="item.appearanceNo"
                  :title="item.appearanceNo + '（' + item.appearanceName + '）'"
                >
                  {{ item.appearanceNo }}（{{ item.appearanceName }}）
                </a-select-option>
              </a-select>
              <a class="zone-interrupt-meter-copy-link" href="javascript:;" @click="copyMeterDisplayName">复制名称</a>
            </div>
            <div v-else class="zone-interrupt-meter-readonly-wrap">
              <span class="zone-interrupt-meter-readonly-text">{{ nowItem.deviceNo }}（{{ nowItem.deviceName }}）</span>
              <a class="zone-interrupt-meter-copy-link" href="javascript:;" @click="copyMeterDisplayName">复制名称</a>
            </div>
          </a-form-item>
          <a-form-item label="计量仪表数据采集频率">
            <div style="display: flex;align-items: center;">
              <a-select style="width: 50%;"
                v-decorator="['collectionFrequency', { rules: [{ required: true, message: '请选择' }] }]"
                placeholder="请选择">
                <a-select-option v-for="(item, index) in collectionFrequencyList" :key="index" :value="item.value">
                  {{ item.title }}
                </a-select-option>
                <a-select-option :value="0">
                  {{ '自定义' }}
                </a-select-option>
              </a-select>
              <span v-if="addOrUpdateForm.getFieldValue('collectionFrequency') != '0'" style="margin-left: 10px;">
                分钟/次</span>
            </div>
            <div v-if="addOrUpdateForm.getFieldValue('collectionFrequency') == '0'"
              style="display: flex;margin-top: 20px;">
              <a-input v-decorator="['num', {
                rules: [{ required: true, message: '请输入', trigger: 'blur' },
                { pattern: /^[1-9]\d*$/, message: '请输入正整数', trigger: 'change' }]
              }]" placeholder="请输入" allow-clear />
              <a-select v-model="Minutesorhours" placeholder="请选择">
                <a-select-option value="分钟"> 分钟/次 </a-select-option>
                <a-select-option value="小时"> 小时/次 </a-select-option>
              </a-select>
            </div>
          </a-form-item>
          <a-form-item label="是否开启报警">
            <a-radio-group v-decorator="['openState', { initialValue: 0, rules: [{ required: true }] }]"
              style="width: 100%">
              <a-radio :value="0">不开启</a-radio>
              <a-radio :value="1">开启</a-radio>
            </a-radio-group>
          </a-form-item>


        </a-form>
      </a-modal>
    </a-card>
  </div>
</template>

<script>
import mixinViewModule from '@/mixin/common'
import axios from 'axios'
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'

export default {
  mixins: [mixinViewModule],
  data() {
    return {
      currentId: '',
      exportDataUrl: 'pipe-network/data_interruption_alarm_setting/export',
      title: '新增',
      isUpdate: false,
      disabled: false,
      equipmentList: [],
      queryUrl: '/pipe-network/data_interruption_alarm_setting/page',
      nowItem: null,
      addOrUpdateUrl: '/pipe-network/alarm_tsl_configs',
      deleteUrl: '/pipe-network/data_interruption_alarm_setting/delete', // 删除数据url
      queryZoneDateUrl: 'zone-metering/zone-metering',
      queryOneUrl: '/pipe-network/data_interruption_alarm_setting/get',
      addOrUpdateVisible: false,
      confirmLoading: false,
      list: [],
      zoneTreeData: [], // 分区数据选项
      importLoading: false, // 导入加载状态
      fileList: [], // 文件列表
      collectionFrequencyList: [
        {
          title: '5',
          value: '5'
        }, {
          title: '10',
          value: '10'
        }, {
          title: '15',
          value: '15'
        }, {
          title: '30',
          value: '30'
        }, {
          title: '60',
          value: '60'
        },
      ],
      query: {
        deviceNo: '',
        deviceName: '',
        alarmType: 2
      },
      Minutesorhours: '分钟',
      columns: [
        {
          title: '分区计量仪表',
          dataIndex: 'deviceName',
          scopedSlots: { customRender: 'deviceNameSlot' }

        },
        {
          title: '报警类型',
          dataIndex: 'pmtName',
          scopedSlots: { customRender: 'pmtNameSlot' }

        },
        {
          title: '是否开启报警',
          dataIndex: 'openState',
          scopedSlots: { customRender: 'openState' }
        },
        {
          title: '分区计量仪表数据采集频率',
          dataIndex: 'collectionFrequency',
          scopedSlots: { customRender: 'collectionFrequency' }

        },
        {
          title: '更改时间',
          dataIndex: 'updateTime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: 150,
          scopedSlots: { customRender: 'action' }
        }
      ],
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }),
      treeDefaultExpandedKeys: [],//默认展开的树节点	

    }
  },
  mounted() {
    this.queryList()
  },
  created() {
    this.resetList()
    this.getZoneData()
    this.queryList()
  },
  watch: {
    zoneTreeData(val) {
      this.chuli(val)

    }
  },
  methods: {
    filterMeterDeviceOption(input, option) {
      const text =
        option.componentOptions &&
        option.componentOptions.children &&
        option.componentOptions.children[0] &&
        option.componentOptions.children[0].text
      if (!text) return false
      return String(text).toLowerCase().indexOf(String(input).toLowerCase().trim()) >= 0
    },
    copyMeterDisplayName() {
      let text = ''
      if (this.disabled && this.nowItem) {
        const no = this.nowItem.deviceNo
        if (no === undefined || no === null || no === '') {
          this.$message.warning('暂无可复制内容')
          return
        }
        text = `${no}（${this.nowItem.deviceName || ''}）`
      } else {
        const deviceNo = this.addOrUpdateForm.getFieldValue('deviceNo')
        if (deviceNo === undefined || deviceNo === null || deviceNo === '') {
          this.$message.warning('请先选择分区计量仪表')
          return
        }
        const item = this.equipmentList.find((e) => String(e.appearanceNo) === String(deviceNo))
        text = item
          ? `${item.appearanceNo}（${item.appearanceName}）`
          : String(deviceNo)
      }
      const ok = () => this.$message.success('已复制到剪贴板')
      const err = () => this.$message.error('复制失败，请重试')
      if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
        navigator.clipboard.writeText(text).then(ok).catch(err)
        return
      }
      const ta = document.createElement('textarea')
      ta.value = text
      ta.setAttribute('readonly', 'readonly')
      ta.style.position = 'fixed'
      ta.style.opacity = '0'
      ta.style.left = '-9999px'
      document.body.appendChild(ta)
      ta.select()
      try {
        if (document.execCommand('copy')) {
          ok()
        } else {
          err()
        }
      } catch (e) {
        err()
      }
      document.body.removeChild(ta)
    },
    resetList() {
      this.query = {
        deviceNo: '',
        deviceName: '',
        alarmType: 2
      }
      this.pagination.current = 1
      this.selectedRows = []
      this.queryList()
    },
    chuli(n) {
      if (n != null && n.length !== 0) {
        n.map((item) => {
          item.title = item.zoneName
          item.children = this.chuli(item.children)

          if (item.level == 1) {
            this.treeDefaultExpandedKeys.push(item.id)
          }
        })
        return n
      } else {
        return n
      }
    },
    treechange(val) {

      this.addOrUpdateForm.setFieldsValue({ deviceNo: null })

      this.$http.get('/pipe-network/data_interruption_alarm_setting/zone/' + val.value).then((res) => {
        this.equipmentList = res.data
      })
    },
    handleOk() {
      const that = this
      // 触发表单验证
      this.addOrUpdateForm.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          console.log(values);

          let params = values
          //自定义
          if (values.collectionFrequency == 0) {
            if (this.Minutesorhours == '小时') {

              params.collectionFrequency = values.num * 60
            } else {
              params.collectionFrequency = values.num

            }
          }


          if (!this.currentId) {
            console.log(1);
            if (values.deviceNo) {
              let deviceName = this.equipmentList.filter(item => item.appearanceNo == values.deviceNo)[0].appearanceName

              params.deviceName = deviceName
            }
            let val = this.addOrUpdateForm.getFieldValue('zoneitem')
            params.zoneName = val.label
            params.zoneId = val.value

            this.$http
              .post('pipe-network/data_interruption_alarm_setting/insert ',
                params
              )
              .then((res) => {

                if (res.code == 0) {
                  this.$message.success(res.message)
                  this.addOrUpdateVisible = false
                  this.resetList()
                } else {
                  this.$message.warning(res.message)
                }
              }).finally(() => {
                that.confirmLoading = false
              })
          } else {
            console.log(2);

            params.id = this.currentId
            this.$http
              .put('pipe-network/data_interruption_alarm_setting/update ',
                params
              )
              .then((res) => {

                if (res.code == 0) {
                  this.$message.success(res.message)
                  this.addOrUpdateVisible = false
                  this.resetList()
                } else {
                  this.$message.warning(res.message)
                }
              }).finally(() => {
                that.confirmLoading = false
              })
          }

        }
      })
    },
    Handle(e) {
      this.disabled = true
      this.title = '编辑'
      this.addOrUpdateVisible = true

     this.nowItem=e
      this.addOrUpdateHandle(e.id)
      this.currentId = e.id

    },
    showModal() {
      this.addOrUpdateVisible = true
    },

    getZoneData() {
      this.$http.get(this.queryZoneDateUrl).then(({ data }) => {
        this.zoneTreeData = data
      })
    },
    // 取消
    handleCancel(e) {
      console.log('Clicked cancel button')
      this.addOrUpdateVisible = false
      this.disabled = false
    },
    // 下载模板
    downloadTemplate() {
      const token = storage.get(ACCESS_TOKEN)
      axios({
        url: process.env.VUE_APP_API_BASE_URL + 'pipe-network/data_interruption_alarm_setting/null/export',
        method: 'get',
        responseType: 'blob',
        headers: {
          Authorization: token
        }
      }).then(res => {
        const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
        const fileName = '数据上传中断报警导入模板.xlsx'
        if ('download' in document.createElement('a')) { // 非IE下载
          const elink = document.createElement('a')
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href) // 释放URL 对象
          document.body.removeChild(elink)
        } else { // IE10+下载
          navigator.msSaveBlob(blob, fileName)
        }
        this.$message.success('模板下载成功')
      }).catch(err => {
        console.error('下载失败:', err)
        this.$message.error('模板下载失败')
      })
    },
    // 文件列表变化
    changeFile(info) {
      this.fileList = info.fileList
    },
    // 自定义上传请求
    customRequest(info) {
      this.importLoading = true
      const formData = new FormData()
      formData.append('file', info.file)
      axios.post(`${process.env.VUE_APP_API_BASE_URL}pipe-network/data_interruption_alarm_setting/list/import/export`, formData, {
        headers: {
          'Authorization': storage.get(ACCESS_TOKEN),
          'Accept': 'application/vnd.ms-excel'
        },
        responseType: 'blob'
      })
        .then(response => {
          const blob = response.data
          console.log('获取到blob:', response)
          if (blob.size == 0) {
            this.$message.success('导入成功')
          } else {
            // 下载逻辑
            const url = window.URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = url
            link.download = `数据上传中断报警导入结果_${new Date().getTime()}.xlsx`
            link.click()
            window.URL.revokeObjectURL(url)

            this.$message.warning('导入成功,但有错误数据,请查看')
          }
        })
        .catch(error => {
          console.log('导入失败:', error)
          this.$message.error('导入失败')
        })
        .finally(() => {
          this.queryList()
          this.importLoading = false
          this.fileList = []
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}

/deep/ .ant-table-thead>tr>th> {
  text-align: center;
}

/deep/ .ant-table-tbody>tr>td {
  text-align: center;
}

/deep/ .zone-interrupt-meter-select.ant-select .ant-select-selection,
/deep/ .zone-interrupt-meter-select.ant-select .ant-select-selection__rendered,
/deep/ .zone-interrupt-meter-select.ant-select .ant-select-selection-selected-value,
/deep/ .zone-interrupt-meter-select.ant-select .ant-select-search__field {
  user-select: text !important;
  -webkit-user-select: text !important;
}

/deep/ .zone-interrupt-meter-select-wrap {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 8px;
}
/deep/ .zone-interrupt-meter-select-wrap .zone-interrupt-meter-select {
  flex: 1;
  min-width: 0;
}
/deep/ .zone-interrupt-meter-readonly-wrap {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 8px;
}
/deep/ .zone-interrupt-meter-readonly-text {
  flex: 1;
  min-width: 0;
  text-align: left;
  user-select: text;
  -webkit-user-select: text;
}
/deep/ .zone-interrupt-meter-copy-link {
  flex-shrink: 0;
  white-space: nowrap;
}
</style>

<style lang="less">
.zone-interrupt-meter-select-dropdown .ant-select-dropdown-menu-item {
  user-select: text !important;
  -webkit-user-select: text !important;
}
</style>
